import DateFormat from 'constants/date_format';
import moment from 'moment';

export function formattedDateTime(date) {
  if (date) {
    date = moment(date).format(DateFormat.LONG_AT_TIME);
  } else {
    date = moment().format(DateFormat.LONG_AT_TIME);
  }
  return date;
}

export function formattedDate(date) {
  if (date) {
    date = moment(date).format(DateFormat.MONTH_DAY_YEAR_SHORT);
  } else {
    date = moment().format(DateFormat.MONTH_DAY_YEAR_SHORT);
  }
  return date;
}

export function formattedUTCDate(date) {
  if (date) {
    date = moment(
      moment(date).utc().format(DateFormat.fixed.ISO8601_LOCAL) + 'Z',
    ).format(DateFormat.LONG_AT_TIME);
  } else {
    date = moment(
      moment().utc().format(DateFormat.fixed.ISO8601_LOCAL) + 'Z',
    ).format(DateFormat.LONG_AT_TIME);
  }
  return date;
}

export function overdueComparison(date) {
  const parsedUTCDate = moment.utc(date).startOf('day');
  const currentUTCDate = moment().utc().startOf('day');
  return parsedUTCDate.isBefore(currentUTCDate, 'day');
}
